import styled from 'styled-components'

export default styled.h3<{ marginBottom?: number }>`
  font-size: 16px;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: ${({ marginBottom }) => marginBottom || 0}px;
`
